import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Blacklist Sources module configurations
export const LISTING_COLUMNS = [
  {
    id: 'value',
    label: 'Source Value',
    width: '20%',
    align: 'left',
    dataKey: 'value',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'type',
    label: 'Source Type',
    width: '20%',
    align: 'left',
    dataKey: 'type',
    sortable: true,
    type: CELL_DATA_TYPES.BLACKLIST_SOURCE_TYPE,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '25%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];
